module.exports = __webpack_public_path__ + "static/media/wind.06ec9738.mp3";